"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var tv4 = require('tv4');

var BI_FILTER = require('../../constant/analytics/bi-filter.constant');

var ARTIFACT_TYPE = require('../../constant/analytics/artifact-type.constant');

var Artifact = /*#__PURE__*/function () {
  function Artifact() {
    var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Artifact);

    this.id = null;
    this.name = null;
    this.type = null;
    this.category = null;
    this.subCategory = null;
    this.biWorkspaceId = null;
    this.biWorkspaceName = null;
    this.biId = null;
    this.biName = null;
    this.biReferenceId = null;
    this.biFilter = null;
    this.active = null;
    this.fillObject(opt);
  }

  _createClass(Artifact, [{
    key: "fillObject",
    value: function fillObject(opt) {
      this.id = opt.id || null;
      this.name = opt.name || null;
      this.type = opt.type || null;
      this.category = opt.category || null;
      this.subCategory = opt.subCategory || null;
      this.biWorkspaceId = opt.biWorkspaceId || null;
      this.biWorkspaceName = opt.biWorkspaceName || null;
      this.biId = opt.biId || null;
      this.biName = opt.biName || null;
      this.biReferenceId = opt.biReferenceId || null;
      this.biFilter = opt.biFilter || null;
      this.active = opt.active || true;
    }
  }, {
    key: "validate",
    value: function validate() {
      return tv4.validateMultiple(this, Artifact.schema());
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'artifact.schema.json',
        type: 'object',
        additionalProperties: false,
        properties: {
          id: {
            type: 'number'
          },
          name: {
            type: 'string',
            maxLength: 100
          },
          type: {
            "enum": ARTIFACT_TYPE.DROP_DOWN.map(function (type) {
              return type.value;
            })
          },
          category: {
            type: 'string',
            maxLength: 100
          },
          subCategory: {
            type: 'string',
            maxLength: 100
          },
          biWorkspaceId: {
            type: 'string',
            maxLength: 100
          },
          biWorkspaceName: {
            type: 'string',
            maxLength: 100
          },
          biId: {
            type: 'string',
            maxLength: 100
          },
          biName: {
            type: 'string',
            maxLength: 100
          },
          biReferenceId: {
            type: 'string',
            maxLength: 100
          },
          biFilter: {
            "enum": BI_FILTER.DROP_DOWN.map(function (type) {
              return type.value;
            })
          },
          active: {
            type: 'boolean'
          }
        },
        required: Object.keys(new Artifact())
      };
    }
  }]);

  return Artifact;
}();

tv4.addSchema(Artifact.schema());
module.exports = Artifact;